// services/specialties.service.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ISpecialty } from "../specialtiesModal";

export const getAllSpecialties = createAsyncThunk(
  "Specialty/FindAllSpeciality",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Speciality/FindAllSpeciality`,
        {
          CustomerName: "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Specialties:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createSpecialty = createAsyncThunk(
  "Specialty/InsertSpeciality",
  async (specialtyData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Speciality/InsertSpeciality`,
        specialtyData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Speciality:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateSpecialty = createAsyncThunk(
  "Specialty/UpdateSpeciality",
  async (specialtyData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Speciality/UpdateSpeciality`,
        specialtyData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Speciality:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteSpecialty = createAsyncThunk(
  "Specialty/DeleteSpeciality",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Speciality/DeleteSpeciality`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Speciality:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getSpecialtyByID = createAsyncThunk(
  "Specialty/FindByIDSpeciality",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Speciality/FindByIDSpeciality`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        Remarks: result.Remarks,
        Image: result.Image,
        IsActive: result.IsActive ? 1 : 2,
      } as ISpecialty;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Speciality:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveSpecialties = createAsyncThunk(
  "Specialty/FindAllActiveSpeciality",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Speciality/FindAllActiveSpeciality`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Active Specialties:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const activeInactiveSpecialty = createAsyncThunk(
  "Specialty/ActiveInActiveSpeciality",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Speciality/ActiveInActiveSpeciality`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Speciality:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// IMAGE UPLOAD
export const specialtyImageUpload = createAsyncThunk(
  "Specialty/ImageSpeciality",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Speciality/ImageSpeciality`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error uploading Speciality Image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
